import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgZorroAntdModule }from '../../ng-zorro-antd/ng-zorro-antd.module';
import { AutorizadorComponent } from './autorizador.component';
import { LancamentoAutorizadorComponent } from './lancamento-autorizador/lancamento-autorizador.component';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';


@NgModule({
  declarations: [AutorizadorComponent, LancamentoAutorizadorComponent],
  exports: [
    LancamentoAutorizadorComponent,
    AutorizadorComponent
  ],
  imports: [
    CommonModule,
    FormsModule, 
    ReactiveFormsModule,
    RouterModule,
    BrowserModule,
    NgZorroAntdModule,
    NgxMaskDirective, NgxMaskPipe
  ],
  providers: [provideNgxMask()],
})
export class AutorizadorModule { }
